export const scheduleTypes = [
  { label: 'Send Email', value: 'SEND_EMAIL' },
  { label: 'Execute External API', value: 'MAKE_API_CALL' },
  { label: 'Map Data in Meta Data Table', value: 'MAP_ALL_DATA' },
];
export const taskFrequencies = [
  { label: 'Every 15 minutes', value: '*/15 * * * *' },
  { label: 'Every 1 hour', value: '0 */1 * * *' },
  { label: 'Every 6 hour', value: '0 */6 * * *' },
  { label: 'Every 12 hour', value: '0 */12 * * *' },
  { label: 'Every 24 hours', value: '0 0 */1 * *' },
];

export const getKeyOfFrequnecy = (expression) => {
  if (!expression) {
    return 'Every 24 hours';
  }
  const frequency = taskFrequencies.find((frequnecy) => frequnecy.value === expression);
  return frequency.label;
};
